var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('m-shopping-cart-3',{staticClass:"mt-4 mb-4",attrs:{"side-bar-continue-text":"ادامه فرایند","empty-cart-image":require('../../assets/empty-cart.svg')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }